// extracted by mini-css-extract-plugin
export var container = "_6g-0";